export function getTaskTrackedSecondsForUser(task, userId, activeTimeSlot = null) {
  const ttbu = task.taskTrackedByUsers.find(t => t.userId === userId);
  const currentTimeSlot = activeTimeSlot?.taskId === task.id
    ? activeTimeSlot
    : ttbu.timeSlots?.[0];
  const currentTimeSlotSeconds = currentTimeSlot?.actualTimeSeconds || 0;

  return task.local || task.localTask
    ? 1
    : Math.floor(ttbu.totalSeconds + currentTimeSlotSeconds);
}
